var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.33325 12.8332C6.33325 12.465 6.63173 12.1665 6.99992 12.1665H12.9999C13.3681 12.1665 13.6666 12.465 13.6666 12.8332C13.6666 13.2014 13.3681 13.4998 12.9999 13.4998H6.99992C6.63173 13.4998 6.33325 13.2014 6.33325 12.8332Z",
    fill: "#5B87EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9999 2.08577C10.8017 2.08577 10.6115 2.16453 10.4713 2.30473L2.26858 10.5075L1.91618 11.9171L3.32577 11.5647L11.5285 3.36192C11.5979 3.2925 11.653 3.21009 11.6906 3.1194C11.7281 3.0287 11.7475 2.93149 11.7475 2.83332C11.7475 2.73515 11.7281 2.63794 11.6906 2.54725C11.653 2.45655 11.5979 2.37414 11.5285 2.30473C11.4591 2.23531 11.3767 2.18025 11.286 2.14268C11.1953 2.10511 11.0981 2.08577 10.9999 2.08577ZM9.52853 1.36192C9.91877 0.971676 10.448 0.752441 10.9999 0.752441C11.2732 0.752441 11.5438 0.806265 11.7963 0.910839C12.0487 1.01541 12.2781 1.16869 12.4713 1.36192C12.6646 1.55514 12.8178 1.78454 12.9224 2.037C13.027 2.28947 13.0808 2.56006 13.0808 2.83332C13.0808 3.10659 13.027 3.37718 12.9224 3.62964C12.8178 3.8821 12.6646 4.1115 12.4713 4.30473L4.138 12.6381C4.05256 12.7235 3.94551 12.7841 3.82829 12.8134L1.16162 13.4801C0.93444 13.5369 0.694115 13.4703 0.528528 13.3047C0.362941 13.1391 0.296375 12.8988 0.353171 12.6716L1.01984 10.005C1.04914 9.88774 1.10976 9.78069 1.19519 9.69525L9.52853 1.36192Z",
    fill: "#5B87EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon-edit.a92f7b5699ea5d16155aeb050d6b4d41.svg";
export { ForwardRef as ReactComponent };